const SUPPORTED_LANGUAGES = ["en", "cs"];
const DEFAULT_LANGUAGE = "cs";

//Determines the active UI language once, at application startup.
//Order of precedence: explicit override (window.___GOP.Language), ?lang= query string, browser language, default.
export function detectLanguage() {
    if (window.___GOP && window.___GOP.Language && SUPPORTED_LANGUAGES.includes(window.___GOP.Language))
        return window.___GOP.Language;

    var queryIndex = window.location.href.indexOf('?');
    if (queryIndex > -1) {
        var query = window.location.href.substring(queryIndex + 1);
        var match = query.split('&').find(part => part.toLowerCase().startsWith('lang='));
        if (match) {
            var lang = decodeURIComponent(match.split('=')[1]).toLowerCase();
            if (SUPPORTED_LANGUAGES.includes(lang))
                return lang;
        }
    }

    var browserLang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    if (browserLang.startsWith("cs"))
        return "cs";

    return DEFAULT_LANGUAGE;
}

//Walks a translation tree (e.g. UITR, or any of the generated *TR.js files) recursively and resolves
//each leaf in place to the legacy single-language shape ({ tr, trL, dataType, ... }) using the given
//language, so existing code using `.tr` / `.trL` (e.g. customizeDataGrid, customizeFormItem) keeps
//working unchanged, and modules that already imported the tree (e.g. `import { UITR } from '...'`)
//see the update, since references are preserved (mutation, not replacement).
export function applyLanguageToTranslationTree(tree, language) {
    if (tree == null || typeof tree !== "object")
        return;

    for (var key of Object.keys(tree)) {
        var value = tree[key];

        if (value == null || typeof value !== "object")
            continue;

        if ("en" in value || "cs" in value) {
            var resolvedValue = value[language] !== undefined ? value[language] : value[DEFAULT_LANGUAGE];
            delete value.en;
            delete value.cs;
            value.tr = resolvedValue;

            if ("trLEn" in value || "trLCs" in value) {
                var resolvedLongValue = language === "cs" && value.trLCs !== undefined ? value.trLCs : value.trLEn;
                delete value.trLEn;
                delete value.trLCs;
                value.trL = resolvedLongValue;
            }
        } else {
            applyLanguageToTranslationTree(value, language);
        }
    }
}